import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  name: "user-vip",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        name: "",
        phone: "",
        remark: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      addDialogVisible: false,
      phone: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    formatPhone: function formatPhone(phone) {
      if (phone.indexOf("+") > -1) {
        return phone.split(" ")[1];
      } else {
        return phone;
      }
    },
    goHouseList: function goHouseList(row) {
      window.open("#/house/list?phone=".concat(this.formatPhone(row.phone)));
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getVipUserList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 设置 | 取消 VIP
    setUserVip: function setUserVip(id) {
      var _this3 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var formData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              formData = {};
              if (id) {
                formData = {
                  userId: id,
                  vip: 0
                };
              } else {
                formData = {
                  phone: _this3.phone,
                  vip: 1
                };
              }
              _context3.n = 1;
              return _this3.$api.setUserVip(formData);
            case 1:
              _this3.$message.success("操作成功");
              _this3.addDialogVisible = false;
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/user/update",
        query: {
          id: row.id
        }
      });
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      return "";
    }
  }
};